import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeMain from '../views/Home/HomeMain'
import LoginMain from "@/views/Auth/LoginMain";
import RegisterMain from "@/views/Auth/RegisterMain";
import DashboardIndexMain from "@/views/Dashboard/DashboardIndexMain";
import ProfileMain from "@/views/Dashboard/ProfileMain";
import CoursesAndInstructorsMain from "@/views/Dashboard/About/CoursesAndInstructorsMain";
import AssessmentsMain from "@/views/Dashboard/AssessmentsMain";
import CoursesMain from "@/views/Dashboard/Courses/CoursesMain";
import AboutUsMain from "@/views/AboutUs/AboutUsMain";
import ContactUsMain from "@/views/ContactUs/ContactUsMain";
import BlogMain from "@/views/Blog/BlogMain";
import CourseBuyMain from "@/views/Dashboard/Courses/CourseBuyMain";
import MyCoursesMain from "@/views/Dashboard/Lessons/MyCoursesMain";
import SessionMain from "@/views/Dashboard/Sessions/SessionMain";
import MyLessonsMain from "@/views/Dashboard/Lessons/MyLessonsMain";
import LessonItemMain from "@/views/Dashboard/Lessons/LessonItemMain";
import NotificationsMain from "@/views/Dashboard/Notifications/NotificationsMain.vue";
import MySessionsMain from "@/views/Dashboard/Sessions/MySessionsMain.vue";
import MeetingMain from "@/views/Dashboard/Sessions/MeetingMain.vue";
import TransactionsMain from "@/views/Dashboard/Transactions/TransactionsMain.vue";
import DictationItemMain from "@/views/Dashboard/Lessons/DictationItemMain.vue";
import WalletCallBackIndexMain from "@/views/WalletCallBackIndexMain.vue";
import SubscriptionMain from "@/views/Dashboard/Subscription/SubscriptionMain.vue";
import SocialNetworkMain from "@/views/Dashboard/SocialNetworkMain.vue";
Vue.use(VueRouter)

const routes = [
    /*HOME*/
    {
        path: '/',
        name: 'home',
        component: HomeMain
    },
    /*LOGIN*/
    {
        path: '/login',
        name: 'login',
        component: LoginMain
    },
    /*LOGIN*/
    {
        path: '/register',
        name: 'register',
        component: RegisterMain
    },
    /*Dashboard*/
    {
        path: '/dashboard',
        name: 'DashboardIndex',
        component: DashboardIndexMain
    },


    /*Dashboard*/
    {
        path: '/wallet/charge',
        name: 'WalletChargeCallBackIndexMain',
        component: WalletCallBackIndexMain
    },

    /*Profile*/
    {
        path: '/dashboard/profile',
        name: 'ProfileMain',
        component: ProfileMain
    },
    /*Profile*/
    {
        path: '/dashboard/subscriptions',
        name: 'SubscriptionMain',
        component: SubscriptionMain
    },
    /*Lessons*/
    {
        path: '/dashboard/my-courses',
        name: 'MyCoursesMain',
        component: MyCoursesMain
    },
    {
        path: '/dashboard/my-courses/lessons/:courseId/:classId',
        name: 'MyLessonsMain',
        component: MyLessonsMain
    },
    {
        path: '/dashboard/my-courses/item/:itemId/:classId/:courseId',
        name: 'LessonItem',
        component: LessonItemMain
    },
    {
        path: '/dashboard/my-courses/dictation/show/:classId/:itemId/:dictationId/:studentId',
        name: 'DictationItemMain',
        component: DictationItemMain
    },
    /*Online Sessions*/
    {
        path: '/dashboard/online-sessions',
        name: 'MySessionsMain',
        component: MySessionsMain
    },
    {
        path: '/dashboard/sessions/:classId',
        name: 'SessionMain',
        component: SessionMain
    },
    {
        path: '/online-session/:meeting_id/:instructor_id',
        name: 'Meeting',
        component: MeetingMain
    },
    /*Online Sessions*/
    {
        path: '/dashboard/about/courses-instructors',
        name: 'CoursesAndInstructorsInformationMain',
        component: CoursesAndInstructorsMain
    },
    /*Assessments*/
    {
        path: '/dashboard/assessments',
        name: 'AssessmentsMain',
        component: AssessmentsMain
    },
    { path: '/dashboard/social', name: 'SocialNetworkMain', component: SocialNetworkMain },
    { path: '/social/share/:token', name: 'SocialNetworkShare', component: SocialNetworkMain },
    /*Assessments*/
    {
        path: '/dashboard/notifications',
        name: 'NotificationsMain',
        component: NotificationsMain
    },
    /*Courses*/
    {
        path: '/dashboard/courses',
        name: 'CoursesMain',
        component: CoursesMain
    },
    /*Buy Course*/
    {
        path: '/dashboard/course/buy/:id',
        name: 'CourseBuyMain',
        component: CourseBuyMain
    },
    /*Transactions*/
    {
        path: '/dashboard/transactions',
        name: 'TransactionsMain',
        component: TransactionsMain
    },
    /*AboutUs*/
    {
        path: '/about-us',
        name: 'AboutUsMain',
        component: AboutUsMain
    },
    /*ContactUs*/
    {
        path: '/contact-us',
        name: 'ContactUsMain',
        component: ContactUsMain
    },
    /*Blog*/
    {
        path: '/blog',
        name: 'BlogMain',
        component: BlogMain
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
